import api from '../config/api';
import {
  FETCH_WFH_LOADING,
  FETCH_WFH_SUCCESS,
  FETCH_WFH_ERROR,
  DELETE_WFH_LOADING,
  DELETE_WFH_SUCCESS,
  DELETE_WFH_ERROR,
  FETCH_WFH_OPERATIONS_LOADING,
  FETCH_WFH_OPERATIONS_SUCCESS,
  FETCH_WFH_OPERATIONS_ERROR
} from '../Types/wfhTypes';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchWFHRequests = (start, end, page, limit, withDispatch = true) => {
  return async dispatch => {
    if (withDispatch) {
      dispatch({ type: FETCH_WFH_LOADING });
    }
    try {
      const query = page && limit ? `?page=${page}&limit=${limit}` : '';
      const response = await api.get(`${API_URL}Request/getWFHRequests/${start}/${end}${query}`);
      if (withDispatch) {
        dispatch({
          type: FETCH_WFH_SUCCESS,
          payload: response.data
        });
      }
      return response.data;
    } catch (error) {
      if (withDispatch) {
        dispatch({
          type: FETCH_WFH_ERROR,
          payload: error.message
        });
      }
      throw error;
    }
  };
};

export const fetchRemoteWorkingOperations = (startDate, endDate, page, limit, filters = {}) => {
  return async dispatch => {
    dispatch({ type: FETCH_WFH_OPERATIONS_LOADING });
    try {
      const queryParams = new URLSearchParams();
      if (page) queryParams.append('page', page);
      if (limit) queryParams.append('limit', limit);
      if (filters.userId) queryParams.append('userId', filters.userId);
      if (filters.validatorId) queryParams.append('operationOwnerId', filters.validatorId);
      if (filters.status) queryParams.append('status', filters.status);

      const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
      const response = await api.get(
        `${API_URL}Request/getRemoteWorkingOperations/${startDate}/${endDate}${query}`
      );

      dispatch({
        type: FETCH_WFH_OPERATIONS_SUCCESS,
        payload: response.data.data
      });
      return response.data.data;
    } catch (error) {
      dispatch({
        type: FETCH_WFH_OPERATIONS_ERROR,
        payload: error.message
      });
      throw error;
    }
  };
};
